/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-select{display:block;position:relative;z-index:9;cursor:pointer}ig-select .drop-down-container{position:absolute;visibility:hidden;border:1px solid #ccc;background:#fff;white-space:nowrap;width:calc(100% - 2px)}ig-select .drop-down-container div[item]{padding:0 8px;line-height:32px;cursor:pointer;text-align:left}ig-select .drop-down-container div[item]:hover{background-color:#bbe1f6}ig-select .drop-down-container.show{visibility:visible}ig-select:hover{cursor:pointer}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/select/select.component.scss.ngstyle.js.pre-build-optimizer.js